module.exports = __webpack_public_path__ + "img/partner4.2a6e3991.png";